/**
 * @generated SignedSource<<0ffdfb28c47f378fc66e74079a37434c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InternalSavingsPlanTransactionState = "CONFIRMED" | "FAILED" | "FINISHED" | "SCHEDULED";
export type InternalSavingsPlanTransactionsInput = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  savingsPlanId?: string | null | undefined;
  state?: InternalSavingsPlanTransactionState | null | undefined;
  states?: ReadonlyArray<InternalSavingsPlanTransactionState> | null | undefined;
};
export type SavingsPlansTransactionsQuery$variables = {
  input?: InternalSavingsPlanTransactionsInput | null | undefined;
};
export type SavingsPlansTransactionsQuery$data = {
  readonly savingsPlanTransactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "InternalSavingsPlanTransaction";
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly name: string | null | undefined;
          readonly price: PrecisionFloat | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly assetAmount: PrecisionFloat | null | undefined;
        readonly createdAt: TimeScalar | null | undefined;
        readonly externalTransaction: {
          readonly id: string;
        } | null | undefined;
        readonly fiat: {
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly fiatAmount: PrecisionFloat | null | undefined;
        readonly id: string;
        readonly parentId: string;
        readonly state: InternalSavingsPlanTransactionState | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type SavingsPlansTransactionsQuery = {
  response: SavingsPlansTransactionsQuery$data;
  variables: SavingsPlansTransactionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    (v9/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SavingsPlansTransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InternalSavingsPlanTransactionsConnection",
        "kind": "LinkedField",
        "name": "savingsPlanTransactions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InternalSavingsPlanTransactionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalSavingsPlanTransaction",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fiat",
                    "kind": "LinkedField",
                    "name": "fiat",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "externalTransaction",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavingsPlansTransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InternalSavingsPlanTransactionsConnection",
        "kind": "LinkedField",
        "name": "savingsPlanTransactions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InternalSavingsPlanTransactionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalSavingsPlanTransaction",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fiat",
                    "kind": "LinkedField",
                    "name": "fiat",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "externalTransaction",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a583b0fa9041a48165b99baf9de6067",
    "id": null,
    "metadata": {},
    "name": "SavingsPlansTransactionsQuery",
    "operationKind": "query",
    "text": "query SavingsPlansTransactionsQuery(\n  $input: InternalSavingsPlanTransactionsInput\n) {\n  savingsPlanTransactions(input: $input) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        __typename\n        id\n        parentId\n        fiatAmount\n        assetAmount\n        createdAt\n        fiat {\n          name\n          symbol\n          id\n        }\n        state\n        externalTransaction {\n          __typename\n          id\n        }\n        asset {\n          id\n          logoUrl\n          symbol\n          price\n          name\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cea7cbebe77f80dd671ddf7539061bf";

export default node;
